import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const ttpPersonExcerptsUrl = `${SERVER_API}/person-excerpt-ttp`;

export const ttpOrganizationExcerptsUrl = `${SERVER_API}/organization-excerpt-ttp`;
